import { forwardRef } from 'react';
import { StyledFieldLabel } from './styled';
import { useFieldContext } from '../../../contexts/field';

const FieldLabel = forwardRef((props, ref) => {
  const { labelProps } = useFieldContext();

  return <StyledFieldLabel {...labelProps(ref, props)} />;
});

export default FieldLabel;
